export default __webpack_public_path__ + "static/media/starwars.0e6e6469.png";